export default __webpack_public_path__ + "static/media/succulent5-big.fb481049.jpg";